import { alpha, ButtonBase, makeStyles, Typography } from "@material-ui/core";
import ProviderAvatar from "../ProviderAvatar";
import { AIProvider } from "@dashboard-v3/api";
import { useTranslation } from "react-i18next";

interface ProviderCardProps {
  provider: AIProvider;
  onSelect: (providerId: string) => void;
}

export default function ProviderCard({
  provider,
  onSelect,
}: ProviderCardProps) {
  const { t } = useTranslation("storage");
  const classes = useStyles();
  const caption = provider.defaultModel || t("externalAI.empty.ownDeployment");

  return (
    <ButtonBase
      className={classes.card}
      onClick={() => onSelect(provider.id)}
      data-testid={`external-ai__provider-${provider.id}`}
    >
      <ProviderAvatar provider={provider} />
      <span className={classes.cardText}>
        <Typography variant="body2" className={classes.cardName}>
          {provider.displayName}
        </Typography>
        <Typography variant="caption" color="textSecondary" noWrap>
          {caption}
        </Typography>
      </span>
    </ButtonBase>
  );
}

const useStyles = makeStyles(theme => ({
  card: {
    display: "flex",
    justifyContent: "flex-start",
    gap: 12,
    padding: "12px 14px",
    textAlign: "left",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    transition: "transform .15s, box-shadow .15s, border-color .15s",
    "&:hover, &:focus-visible": {
      transform: "translateY(-2px)",
      borderColor: theme.palette.primary.main,
      boxShadow: `0 6px 16px ${alpha(theme.palette.primary.main, 0.16)}`,
    },
  },
  cardText: { display: "flex", flexDirection: "column", minWidth: 0 },
  cardName: { fontWeight: 500 },
}));
